module.exports = __webpack_public_path__ + "static/media/C8.8425f386.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C8.png
// module id = 900
// module chunks = 0